import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class StudentGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    // First check if user is authenticated
    if (!this.auth.isAuthenticated()) {
      return this.router.parseUrl('/login');
    }

    // Then check if user is a student
    if (this.auth.isStudent()) {
      return true;
    }

    // If authenticated but not a student, redirect based on role
    const userRole = this.auth.getUserRole();
    switch (userRole) {
      case 'ADMIN':
      case 'TEACHER':
        // Redirect admin/teacher to admin dashboard
        return this.router.parseUrl('/admin');
      case 'PARENT':
        // Redirect parent to appropriate dashboard (if exists)
        // For now, redirect to home page
        return this.router.parseUrl('/');
      default:
        // Unknown role, redirect to login
        return this.router.parseUrl('/login');
    }
  }
}